// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Selectors
import { getPoiCount, getPoiTargetPoint, getPoiTargetRect } from '../../poiSelector';

// Components
import Pointer from './Pointer';

const PointerContainer = (props) => {
    const { pointer } = props;

    const changeCount = getPoiCount(pointer) || 0;

    return (
        <Pointer
            {...props}
            large={changeCount > 9}
            targetPoint={getPoiTargetPoint(pointer)}
            targetRect={getPoiTargetRect(pointer)}
        >
            {changeCount}
        </Pointer>
    );
};

PointerContainer.propTypes = {
    pointer: PropTypes.object.isRequired,
    layerRect: PropTypes.object.isRequired,
    color: PropTypes.string,
};

export default PointerContainer;
